import { nextTick } from '@rehaje/shared'

import { observe } from './observe'
import { addEndBatchEffect } from './signal'

import type { ObserveEvent, ObserveOptions } from './types'
import type { Callback } from '@rehaje/shared'

export interface BatchObserver {
  (events: ObserveEvent[]): void
}

export function batchObserve(
  target: any,
  observer: BatchObserver,
  options?: ObserveOptions
): Callback {
  let observeEvents: ObserveEvent[] = []

  const endBatchEffectDispose = addEndBatchEffect(() => {
    if (observeEvents.length > 0) {
      const events = observeEvents
      observeEvents = []
      if (options?.async === false) observer(events)
      else nextTick(() => observer(events))
    }
  })

  const observeDispose = observe(
    target,
    (event) => {
      observeEvents.push(event.toJSON())
    },
    { ...options, async: false }
  )

  return () => {
    endBatchEffectDispose()
    observeDispose()
  }
}
